import React from 'react';
import { Container, Card } from '@scentregroup/ui';
import classNames from 'classnames';
import Markdown from '../markdown';
import Article from '../article';
import ResponsiveImage from '../responsive-image';
import PotentialLink from '../potential-link';
import analyticsUtils from '../../helpers/analytics-utils';
import { STATUS_NOT_FOUND } from '../../constants';
import style from './index.module.scss';
import errorMessages from './static-content.js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorFeature = _ref => {
  let {
    error,
    status
  } = _ref;
  const INDENT = 2;
  const content = errorMessages[status] || errorMessages['default'];
  const devMessage = "\n  ```\n  ".concat(JSON.stringify(error, null, INDENT), "\n  ```\n  ");
  // Tracks 404 events for analytics
  if (status && status === STATUS_NOT_FOUND) {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.NOT_FOUND_404
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: style.ErrorFeature,
    "data-id": "error-feature_index_ErrorFeature_div",
    children: [/*#__PURE__*/_jsx(PotentialLink, {
      link: content.link,
      "data-id": "error-feature_index_ErrorFeature_div_PotentialLink",
      children: /*#__PURE__*/_jsx(ResponsiveImage, {
        lazyLoad: false,
        angleOrigin: 'top-right',
        desktopImageUrl: content.imageUrl,
        mobileImageUrl: content.imageUrl,
        mobileRatio: "standard",
        desktopRatio: "feature",
        numberOfItems: 1,
        alt: content.title,
        "data-id": "error-feature_index_ErrorFeature_PotentialLink_ResponsiveImage"
      })
    }), /*#__PURE__*/_jsx(Container, {
      centred: true,
      type: "large",
      className: classNames(style.Container),
      "data-id": "error-feature_index_ErrorFeature_div_Container",
      children: /*#__PURE__*/_jsx(Card, {
        className: style.Card,
        "data-id": "error-feature_index_ErrorFeature_Container_Card",
        children: /*#__PURE__*/_jsxs(Article, {
          link: content.link,
          heading: content.title,
          "data-id": "error-feature_index_ErrorFeature_Card_Article",
          children: [/*#__PURE__*/_jsx(Markdown, {
            content: content.body,
            "data-id": "error-feature_index_ErrorFeature_Article_Markdown"
          }), typeof __DEV__ !== 'undefined' && __DEV__ && error && /*#__PURE__*/_jsx(Markdown, {
            content: devMessage,
            "data-id": "error-feature_index_ErrorFeature_Markdown_7"
          })]
        })
      })
    })]
  });
};
export default ErrorFeature;